<template>
  <v-chart :options="options" />
</template>

<script>
import { DEFAULT_COLORS } from '@/constants';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      default() {
        return DEFAULT_COLORS;
      },
    },
    animation: {
      type: Boolean,
      default: true,
    },
    areaStyle: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    valuesWithPercentLabel() {
      // 부모에게서 받은 values.name을 label로 사용하지 않고,
      // 각 값의 %를 계산하여 label로 사용하고자, values.name을 치환함.
      const initRtn = 0;
      const sum = this.values.reduce((rtn, el) => {
        return rtn + el.value;
      }, initRtn);
      return this.values.map(el => {
        let name = '';
        let rate = Math.ceil((el.value * 100) / sum);
        if (rate > 0) name = `${rate} %`;
        return { value: el.value, name: name };
      });
    },
    options() {
      return {
        animation: this.animation,
        color: this.colors,
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
        xAxis: {
          axisLine: { show: false },
        },
        yAxis: {
          axisLine: { show: false },
        },
        tooltip: {
          trigger: 'item',
          transitionDuration: 0,
          formatter: params => {
            // console.log(params); 의 결과를 참조.
            // 툴팁에는 부모에게서 받은 values.name을 사용하고자 하는 것임.
            return `${this.values[params.dataIndex].name} : ${params.value}`;
          },
          textStyle: {
            fontSize: 12,
          },
        },
        series: this.series,
      };
    },
    series() {
      return [
        {
          type: 'pie',
          center: ['50%', '50%'],
          label: {
            position: 'inner',
          },
          hoverAnimation: false,
          selectedMode: 'single',
          radius: ['30%', '80%'], // eslint-disable-line
          data: this.itemStyle(this.valuesWithPercentLabel),
        },
      ];
    },
  },
  methods: {
    itemStyle(values) {
      return values.map((val, index) => {
        return {
          ...val,
          itemStyle: (() => {
            let style = {};
            if (this.areaStyle == 'gradation') {
              style = this.areaStyleGradation(this.colors[index]);
            } else if (this.areaStyle == 'linearGradient') {
              style = this.areaStyleLinearGradient(this.colors[index], 20, 40);
            } else if (this.areaStyle == 'spinLinearGradient') {
              style = this.areaStyleSpinLinearGradient(this.colors[index], 20, 40);
            }
            return style;
          })(),
        };
      });
    },
  },
};
</script>
